import { Invoice, Plan } from '../models/Billing'
import { PROFILE_URL } from '../helpers/urls'
import { SBAPIFetch } from '../helpers/SBAPIHelper'
import { ProfilePricingTable } from '../models/Profile'

const fetchPricingTable = (profileSlug: string): Promise<ProfilePricingTable> =>
  SBAPIFetch<ProfilePricingTable>(
    `${PROFILE_URL}/${profileSlug}/pricing-table`
  ).then((response) => response.data)

const fetchBillingPortalUrl = (profileSlug: string): Promise<{ url: string }> =>
  SBAPIFetch<{ url: string }>(
    `${PROFILE_URL}/${profileSlug}/billing-portal`
  ).then((response) => response.data)

const fetchInvoices = (profileSlug: string): Promise<Invoice[]> =>
  SBAPIFetch<Invoice[]>(`${PROFILE_URL}/${profileSlug}/invoices`).then(
    (response) => response.data
  )

const fetchPlan = (profileSlug: string): Promise<Plan | undefined> =>
  SBAPIFetch<Plan | null>(`${PROFILE_URL}/${profileSlug}/plan`).then(
    (response) => response.data ?? undefined
  )

export { fetchPricingTable, fetchBillingPortalUrl, fetchInvoices, fetchPlan }
